import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

interface EmployeeRecord {
  date: string;
  income: number;
  supply: number;
  turn: number;
}

interface EmployeeRecordsTableProps {
  records: EmployeeRecord[];
  employeeName: string;
}

const EmployeeRecordsTable = ({ records, employeeName }: EmployeeRecordsTableProps) => {
  return (
    <div className="p-4">
      <h3 className="text-lg font-semibold mb-4">7-Day Records for {employeeName}</h3>
      <div className="-mx-2">
        <Table>
          <TableHeader>
            <TableRow className="hover:bg-transparent">
              <TableHead className="h-7 text-xs font-medium">Date</TableHead>
              <TableHead className="text-right h-7 text-xs font-medium">Income</TableHead>
              <TableHead className="text-right h-7 text-xs font-medium">Supply</TableHead>
              <TableHead className="text-right h-7 text-xs font-medium">Turn</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {records.map(record => (
              <TableRow key={record.date} className="hover:bg-gray-200/60">
                <TableCell className="py-1.5 text-sm">{record.date}</TableCell>
                <TableCell className="text-right py-1.5 text-sm">
                  {record.income.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}
                </TableCell>
                <TableCell className="text-right py-1.5 text-sm">
                  {record.supply.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}
                </TableCell>
                <TableCell className="text-right py-1.5 text-sm">
                  {record.turn.toFixed(1)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default EmployeeRecordsTable;
